import { render } from "./CollectionWrapper.vue?vue&type=template&id=2239e6d4"
import script from "./CollectionWrapper.vue?vue&type=script&lang=js"
export * from "./CollectionWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__